import clsx from 'clsx';
import { format, isBefore } from 'date-fns';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from '../calendar';
import { InputCalendarProps } from './InputCalendarProps';
import styles from './styles.module.scss';

export const InputCalendar = ({
  minSelectableDate,
  maxSelectableDate,
  selectedDate,
  onChange,
  labelInput,
  displaySubline = false,
  align = 'left',
  index = 1,
  disabled = false,
}: InputCalendarProps) => {
  const { t } = useTranslation();
  const refInput = useRef<HTMLInputElement>(null);

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const popoverElement = document.getElementsByClassName(`popover${index}`);
  const isDateInThePast = selectedDate && isBefore(selectedDate[0], new Date());
  const isDateSelected = selectedDate && selectedDate.length > 0;

  document.addEventListener('click', (e) => {
    if (
      !(
        popoverElement[0]?.contains(e.target as Node) ||
        popoverElement[1]?.contains(e.target as Node)
      )
    ) {
      setIsPopoverOpen(false);
    }
  });

  return (
    <div data-testid="input-calendar-component">
      <div className="popover-container vtmn-relative vtmn-inline-block">
        <label
          className="vtmn-text-input_label"
          htmlFor={`overview-input-${index}`}
        >
          {labelInput}
        </label>
        <div className={`vtmn-text-input_container popover${index}`}>
          <input
            data-testid={`input-calendar-${index}`}
            value={
              isDateSelected
                ? format(new Date(selectedDate[0]), 'dd/MM/yyyy')
                : ''
            }
            type="text"
            className={clsx([
              styles['spo-calendar-input-field'],
              'vtmn-text-input',
              isDateInThePast && 'vtmn-text-input--error',
            ])}
            id={`overview-input-${index}`}
            placeholder="Choose a date"
            aria-describedby={
              isDateInThePast
                ? `error-input-helper-${index}`
                : `overview-input-helper-${index}`
            }
            required
            readOnly
            onClick={() => setIsPopoverOpen(true)}
            ref={refInput}
            disabled={disabled}
          />
          <span
            className="vtmx-calendar-line"
            aria-hidden="true"
            onClick={() => !disabled && setIsPopoverOpen(true)}
            ref={refInput}
          />
        </div>
        {displaySubline && (
          <div
            id={
              isDateInThePast
                ? `error-input-helper-${index}`
                : `overview-input-helper-${index}`
            }
            className={clsx(
              'vtmn-text-input_helper-text',
              (isDateInThePast || isDateSelected) &&
                'vtmn-text-input_helper-text--error',
            )}
          >
            {isDateSelected
              ? t('calendar.change_date_warning')
              : t('calendar.description_input')}
          </div>
        )}
        {isPopoverOpen && (
          <div
            className={`${styles['spo-calendar-popover']} ${styles[align]} calendar-popover vtmn-absolute popover${index}`}
          >
            <Calendar
              minSelectableDate={minSelectableDate}
              maxSelectableDate={maxSelectableDate}
              selectedDate={selectedDate}
              setIsPopoverOpen={setIsPopoverOpen}
              onChangeDate={onChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};
